import React from "react";
import Wrapper from "../../../../hoc/Wrapper/Wrapper";
import { Button, Dialog, DialogContent } from "@material-ui/core";
import {
  Document,
  Font,
  Page,
  PDFDownloadLink,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import iransans from "../../../../assets/fonts/vazir/Farsi-Digits-Without-Latin/Vazir-FD-WOL.ttf";
import { nameVariables } from "../CarContractItems";
import momentJalai from "moment-jalaali";
import TextPdfFix from "../../../UI/TextPdfFix";

function formatCurrency(n, currency) {
  return (
    currency +
    n.toFixed(0).replace(/./g, function (c, i, a) {
      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
    })
  );
}

const CarContractSalePrint = (props) => {
  const [openModal, setOpenModal] = React.useState(false);
  const { data } = props;

  return (
    <Wrapper>
      <Button variant={"outlined"} onClick={(e) => setOpenModal(true)}>
        چاپ نقدی
      </Button>
      <Dialog
        open={openModal}
        onClose={(e) => setOpenModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <PDFDownloadLink
            document={
              <CarCOntractPdfGenerator data={data} title={"فرم معامله ماشین"} />
            }
            fileName="download_pdf.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? "در حال آماده سازی فایل ..." : "دانلود نمایید!"
            }
          </PDFDownloadLink>
        </DialogContent>
      </Dialog>
    </Wrapper>
  );
};

const Table = ({ children }) => (
  <View
    style={{
      marginTop: 8,
      marginBottom: 8,
      // borderTop: "1 solid black",
      // borderLeft: "1 solid black",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {children}
  </View>
);

const TableRow = ({ style, children }) => (
  <View
    style={{
      display: "flex",
      flexDirection: "row",
      textAlign: "center",
      ...style,
    }}
  >
    {children}
  </View>
);

const TableCell = ({ style, children }) => (
  <View
    style={{
      flex: 1,
      // borderRight: "1 solid black",
      // borderBottom: "1 solid black",
      paddingRight: 3,
      paddingTop: 3,
      paddingBottom: 3,
      textAlign: "right",
      direction: "ltr",
      ...style,
    }}
  >
    <Text>{children}</Text>
  </View>
);

const CarCOntractPdfGenerator = (props) => {
  Font.register({
    family: "IRANSans",
    src: iransans,
  });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
      fontFamily: "IRANSans",
      fontSize: 10,
    },
    header: {
      fontSize: 18,
      textAlign: "right",
    },
    cellHeader: {
      fontSize: 8,
      textAlign: "center",
      display: "flex",
      flexDirection: "row",
    },
  });

  let deliver_item = JSON.parse(props.data.delivered_items);

  const showItems = (item) => {
    return item ? <Text style={{ color: "green" }}>دارد</Text> : "-";
  };

  return (
    <Document
      file="somefile.pdf"
      onLoadSuccess={(e) => {}}
    >
      <Page size="A4" style={styles.body}>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <View>
            <View>
              <Text>
                ن / ف{props.data.document_number}
                شماره سند :
              </Text>
            </View>
            <View>
              <Text>
                {props.data.document_date_fa}
                تاریخ سند :
              </Text>
            </View>
          </View>
          <View style={{ width: 300, textAlign: "center", direction: "rtl" }}>
            <Text>به نام خدا</Text>
            <Text>قرارداد واگزاری</Text>

            <Text>غیر قابل انتقال</Text>
          </View>

          <View
            style={{
              paddingTop: 5,
              textAlign: "right",
              fontSize: 13,
              width: 100,
            }}
          >
            <Text>بنگاه فریدونی</Text>
          </View>
        </View>

        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text>فروشنده :</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.id_number}
                شماره شناسنامه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.father}
                فرزند :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.lastname} {props.data.Seller.name}
                آقا یا خانم :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.postal_code}
                کد پستی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.id_card_number}
                شماره ملی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Seller.place_of_issuance}
                صادره از :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Seller.mobile).join(",")}
                شماره همراه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Seller.phone).join(",")}
                تلفن ثابت :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                <TextPdfFix text={props.data.Seller.address} />
                آدرس :
              </TableCell>
            </TableRow>
          </Table>
        </View>

        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text style={{ fontSize: 13 }}>خریدار</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.id_number}
                شماره شناسنامه :{" "}
              </TableCell>

              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.father}
                فرزند :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.lastname} {props.data.Buyer.name}
                آقا یا خانم :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.postal_code}
                کد پستی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.id_card_number}
                شماره ملی :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.Buyer.place_of_issuance}
                صادره از :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Buyer.mobile).join(",")}
                شماره همراه :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {JSON.parse(props.data.Buyer.phone).join(",")}
                تلفن ثابت :{" "}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                <TextPdfFix text={props.data.Buyer.address} />
                آدرس :
              </TableCell>
            </TableRow>
          </Table>
        </View>
        <View style={{ direction: "rtl", textAlign: "right" }}>
          <View
            style={{
              borderBottom: "1 solid black",
              fontWeight: "bold",
              width: "100%",
            }}
          >
            <Text style={{ fontSize: 13 }}>مورد واگذاری</Text>
          </View>
          <Table style={{ border: "none" }}>
            <TableRow>
              <TableCell
                style={{ border: "none", flex: "auto", width: "120px" }}
              >
                {props.data.manufacture_date}
                سال ساخت :{" "}
              </TableCell>
              <TableCell
                style={{ border: "none", flex: "auto", width: "120px" }}
              >
                {props.data.car_color}
                رنگ :
              </TableCell>
              <TableCell style={{ border: "none", flex: "auto", width: "290" }}>
                {props.data.car_type}
                یک دستگاه خودروی سواری :{" "}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.chassis_number}
                شماره شاسی :{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.vin_number}: VIN شماره
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.motor_number}
                شماره موتور :
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.current_tag}
                پلاک اتتظامی شماره :{" "}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}>
                {props.data.remained
                  ? formatCurrency(props.data.remained, "")
                  : 0}
                {" : "} الباقی ثمن معامله{" "}
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.prepayment
                  ? formatCurrency(props.data.prepayment, "")
                  : ""}
                {" : "} پیش پرداخت
              </TableCell>
              <TableCell style={{ border: "none" }}>
                {props.data.price ? formatCurrency(props.data.price, "") : ""}
                {" : "} کل ثمن معامله
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ border: "none" }}>
                فقره چک به شرح پشت این قرارداد توسط خریدار به فروشنده پرداخت
                گردید.
                {props.data.cheques ?? 0}
                می باشد که طی
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                خریدار خودروی مذکور را با دقت رویت نموده و از کل کم و کیف آن
                مطلع می باشد و با توجه به شرایط خاص بازار از نظر نوسانات
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 1
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                قیمت ارزش خودرو مورد تایید می باشد و به هیچ وجه قابل فسخ نمی
                باشد حتی خیار غبن و تدلیس را از خود ساقط نمود.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                تا تسویه حساب کامل ثمن معامله و اعلام وصول آن این قرارداد فاقد
                هرگونه ارزش و اعتبار قانونی و شرعی می باشد.
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 2
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                سند خودروی مذکور فقط به صورت وکالت فروش با اعتبار 01 روز جهت فک
                پلاک توسط خریدار به فروشنده اعطا می گردد و الباقی
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 3
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                مدارک شامل سند و فاکتور فروش و بنچاق های قطعی قبلی تا ارائه برگه
                تایید تعویض پلاک و عدم خلاف نزد فروشنده خواهد ماند.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                خریدار متعهد گردید ظرف مدت ۱۰ روز پلاک فروشنده را فک و با عدم
                خلاف تحویل فروشنده دهد و در غیر این صورت طبق ماده 136
              </TableCell>
              <TableCell style={{ flex: "auto", width: "30px" }}>
                - بند 4
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                قانون مدنی مصداق خیانت در امانت بوده و عواقب خاص خودش را در پی
                خواهد داشت .
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                این قرارداد و عین 4 بند مندرج در آن در حضور شاهدین ذیل این
                قرارداد که حضورشان مورد تایید است در نهایت صحت و سلامت عقل و
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                جسم و با آگاهی کامل از عوارض ناشی از آن و بدون هیچ اجبار و تردید
                با دقت مطالعه و تفهیم و مورد تایید قرار گرفت.
              </TableCell>
            </TableRow>
          </Table>
        </View>

        <View>
          <Table>
            <TableRow>
              <TableCell>
                با کلیه متعلقات و
                {momentJalai(props.data.delivery_date)
                  .format("jDD-jMM-jYYYY")
                  .split("")
                  .reverse()
                  .join("")}
                {"  "}
                {momentJalai(props.data.delivery_date)
                  .format("HH:mm")
                  .split("")
                  .reverse()
                  .join("")}
                خودرو مذکور راس ساعت
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {showItems(deliver_item.key_card)}: {nameVariables.key_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.spare_key)}: {nameVariables.spare_key}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.body_insurance)}:{" "}
                {nameVariables.body_insurance}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.third_party_insurance)}:{" "}
                {nameVariables.third_party_insurance}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.id_card)}: {nameVariables.id_card}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {showItems(deliver_item.technical_inspection)}:{" "}
                {nameVariables.technical_inspection}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.mayoralty_charges)}:{" "}
                {nameVariables.mayoralty_charges}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.fuel_card)}: {nameVariables.fuel_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.golden_card)}:{" "}
                {nameVariables.golden_card}
              </TableCell>
              <TableCell>
                {showItems(deliver_item.garranty_card)}:{" "}
                {nameVariables.garranty_card}
              </TableCell>
            </TableRow>
            <TableRow style={{ paddingTop: 20 }}>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای خریدار
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای فروشنده
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                توسط فروشنده به خریدار تحویل گردید.
                {"  "}
                {props.data.inspection_date
                  ? momentJalai(props.data.inspection_date)
                      .format("jDD-jMM-jYYYY")
                      .split("")
                      .reverse()
                      .join("")
                  : ""}
                {"  "}
                {props.data.inspection_date
                  ? momentJalai(props.data.inspection_date)
                      .format("HH:mm")
                      .split("")
                      .reverse()
                      .join("")
                  : ""}
                {"  "}
                تاریخ
                {"  "}
                {props.data.inspection_center}
                {"  "}و تاییدیه کارشناسی مرکز
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>شرایط پرداخت</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextPdfFix text={props.data.payment_terms} />
              </TableCell>
            </TableRow>
            <TableRow style={{ paddingTop: 1 }}>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>امضای شاهد</TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای خریدار
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>
                امضای فروشنده
              </TableCell>
            </TableRow>
          </Table>
        </View>
      </Page>
    </Document>
  );
};
export default CarContractSalePrint;
